module.exports = __webpack_public_path__ + "static/img/logo.a907cc1b.png";